import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomTextField from '../base/CustomTextField';

/**
 * Prompt user for input: phone number
 * @returns {ReactElement} textfield prompting for phone number
 */
const PhoneNumber = () => {
	return (
		<CustomTextField
			name={NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER}
			label='Personal Phone Number'
		/>
	);
};
export default PhoneNumber;
